// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hREv","colMin":"styles_colMin__Il-kw"};